import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import ContactUs from '../components/ContactUs'

const ContactUsContainer = () => {
  const { t } = useTranslation()
  return <ContactUs t={t} />
}

export default memo(ContactUsContainer)
